import { ComponentType } from 'react';

import { captureSentryException } from '../SentryUtils';

export function componentLoader(
  lazyComponent,
  attemptsLeft = 5,
  interval = 2000
): Promise<{ default: ComponentType<any> }> | Promise<any> {
  return new Promise((resolve, reject): void => {
    lazyComponent()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (attemptsLeft === 1) {
            captureSentryException(error);
            reject(error);
            return;
          }
          componentLoader(lazyComponent, attemptsLeft - 1, interval).then(
            resolve,
            reject
          );
        }, interval);
      });
  });
}
